import { render, staticRenderFns } from "./FinanceShareholderReport.vue?vue&type=template&id=0bd040fb&scoped=true"
import script from "./FinanceShareholderReport.vue?vue&type=script&lang=js"
export * from "./FinanceShareholderReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd040fb",
  null
  
)

export default component.exports